import styled from 'styled-components';

export default styled.div`
  color: red;
`;
